import { bedsServices } from "../../Services/BedsServices/beds.services";


const bedsListing = async (params) => {
    let response = await bedsServices.bedsListing(params);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const bedsCreate = async () => {
    let post = {
        "bed_number": "14",
        "room_id": "13"
    }
    let response = await bedsServices.bedsCreate(post);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const bedsDetail = async (id) => {
    let response = await bedsServices.bedsDetail(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const bedsUpdate = async (id) => {
    let response = await bedsServices.bedsUpdate(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const bedsDelete = async (id) => {
    let response = await bedsServices.bedsDelete(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const bedsController = {
    bedsListing,
    bedsCreate,
    bedsDetail,
    bedsUpdate,
    bedsDelete
};

export default bedsController;
